import { Components, Theme } from '@mui/material/styles';

export default function MuiChip(theme: Theme): Components['MuiChip'] {
  return {
    defaultProps: {
      variant: 'outlined',
    },
    styleOverrides: {
      root: {},
    },
  };
}
